import rendererSVG from '../helper/rendererSvg'
const createText = rendererSVG.createText

export const createValue = chart => {
    const { renderer, series, plotLeft, plotTop } = chart

    const point1 = series[0].data[0]
    console.log("point1", point1)
    const { shapeArgs, type_1, type_2, y, max, text, fontColor, valueText } = point1
    const { innerR } = shapeArgs
    const stroke = 1
    const fontSize = innerR / 2
    const textStyle = {
        align: 'center',
        'text-anchor': 'middle',
        'pointer-events': 'auto',
        fill: 'currentColor',
        'font-Family': `"SourceSansPro-Semibold", Arial, "Helvetica Neue", Helvetica, sans-serif`,
        fontWeight: 'bold',
        fontSize: fontSize,
        color: fontColor
    }
    const textStyle2 = { ...textStyle, fontSize: fontSize * 0.6 }
    const styleBoxTextTitle = {
        'alignment-baseline': 'central',
        'stroke-width': 0,
        stroke: 'transparent !important',
        zIndex: 0,
        rx: 1,
        ry: 1
    }

    const def = Math.sin((45 * Math.PI) / 180) * innerR
    const centerX = shapeArgs.x + plotLeft
    const centerY = shapeArgs.y - innerR + plotTop
    const x1 = centerX - def
    const y1 = centerY + (innerR - def)
    const x2 = def * 2
    const y2 = def * 2

    const titleBox = renderer
        .rect(x1, y1, x2, y2)
        .attr(styleBoxTextTitle)
        .add()
    const bbox = titleBox.getBBox(true)

    const componentLabel = (typeValue, percent, value, max, text, valueText) => {
        if (typeValue == 'percent') {
            return `<div >
        <label> ${Math.round(percent * 100) / 100}%</label>
        </div>`
        }
        if (typeValue == 'compare') {
            return `<div>
        <p> <b>${valueText || value}</b>/${max}</p>
        </div>`
        }
        if (typeValue == 'text') {
            return `<div >
        <label> ${text}</label>
        </div>`
        }
        if (typeValue == 'value') {
            return `<div>
        <label > ${valueText || value}</label>
        </div>`
        }
        return null
    }

    const label = componentLabel(type_1, y, y, max, text, valueText)
    const label2 = componentLabel(type_2, y, y, max, text, valueText)

    const t1 = createText(
        renderer,
        label,
        bbox.x + bbox.width / 2,
        bbox.y + bbox.height / 2 + fontSize / 4 - stroke * 2,
        { zIndex: 5, class: 'title-chart' },
        textStyle
    )

    const t2 = createText(
        renderer,
        label2,
        bbox.x + bbox.width / 2,
        bbox.y + bbox.height / 2 + fontSize - stroke * 2,
        { zIndex: 5, class: 'title-chart' },
        textStyle2
    )

    chart._elements.push({ rectElement: [t1, t2, titleBox] })
}
